import React, { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import { MaterialStyleMap } from '../../types';

const LinkBehavior = forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }>(
  (props, ref) => {
    const { href, ...other } = props;

    return <RouterLink ref={ref} to={href} {...other} />;
  },
);

LinkBehavior.displayName = 'LinkBehavior';

export default (): MaterialStyleMap => ({
  MuiButton: {
    styleOverrides: {
      root: {
        boxShadow: 'unset',
        '&[aria-pressed="true"]': {
          textDecoration: 'underline',
          fontWeight: 'normal',
        },
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      LinkComponent: LinkBehavior,
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        '& .fa': {
          lineHeight: '1.5rem',
          minHeight: '1.5rem',
          minWidth: '1.5rem',
        },
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        minHeight: '1em',
        minWidth: '1em',
        padding: '0 9px',
      },
    },
  },
  MuiSvgIcon: {
    styleOverrides: {
      fontSizeSmall: {
        fontSize: '1rem',
      },
    },
  },
});
